<template>
  <div class="question">
<!--    <Profile />-->
        <Question />
  </div>
</template>

<script>
// import Profile from '@/components/Profile.vue'
import Question from '@/components/Question.vue'
export default {
  name: 'QuestionView',
  components: {
    Question
  },
  mounted(){
    setTimeout(function(){
      let height = document.getElementById('main_component_wraper').clientHeight;
      parent.postMessage({height:height - 100}, '*')
    },300)
  }
}
</script>
<style scoped>
.question {
  max-width: 420px;
  width: 100%;
  margin: auto;
  background:var(--background-color);
  overflow: auto;
}
</style>
